export default __webpack_public_path__ + "static/media/SD-19.2a701cc1.jpg";